import "./loader.css";

export default function Loader() {
    return (
        <div id={"loader"}/>
    );
}
